import { lazy, Suspense, type JSX } from 'react';

import type { MermaidExportTarget } from './mermaid-block-context.js';
import { MermaidCode } from './MermaidCode.js';

const MermaidBlock = lazy(async () => ({
  default: (await import('./MermaidBlock.js')).MermaidBlock,
}));

/**
 * A Mermaid block for the chat and the file preview. The drawing code is loaded only when a page
 * actually contains a block, so neither surface pays for it otherwise.
 */
export function LazyMermaidBlock({
  source,
  target,
}: {
  source: string;
  target: MermaidExportTarget | null;
}): JSX.Element {
  return (
    <Suspense fallback={<MermaidCode source={source} />}>
      <MermaidBlock source={source} target={target} />
    </Suspense>
  );
}
